import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-ContentPersonas', [
  'addButton',
  'personasList',
  'titleInput',
  'nameInput',
  'descriptionInput',
  'emotionalRegisterInput',
  'saveButton',
  'deleteDialog',
  'loadingSpinner',
  'emptyState',
]);
